import { BeneficioService } from "services/comunicacion-cultura";
import { loadingAtom, openModalSolicitarBeneficioAtom } from "../store/store";
import { useAtom } from "jotai";
import useBeneficiosPage from "./useBeneficiosPage";
import { message } from "antd";

const useModalSolicitarBeneficio = () => {

    const [open, setOpen] = useAtom(openModalSolicitarBeneficioAtom);
    const [loading, setLoading] = useAtom(loadingAtom);
    const { fetchBeneficios } = useBeneficiosPage();

    const abrirModal = () => {
        setOpen(true);
    }

    const cerrarModal = () => {
        setOpen(false);
    }

    const guardar = async (formInstance) => {
        formInstance
            .validateFields()
            .then(async (payload) => {
                try {
                    setLoading(true);
                    await BeneficioService.insertar(payload);
                    fetchBeneficios();
                    setLoading(false);
                    formInstance.resetFields();
                    cerrarModal();
                } catch (error) {
                    if (error.response && error.response.data) {
                        const mensajeError = error.response.data.mensaje;
                        console.log('Error del servidor:', mensajeError);
                        message.error(mensajeError);
                    }
                } finally {
                    setLoading(false);
                }
            })
            .catch((info) => {
                console.log('Validate Failed:', info);
                setLoading(false);
            });
    }

    return {
        open,
        loading,
        abrirModal,
        cerrarModal,
        guardar
    };
};

export default useModalSolicitarBeneficio;